import React from 'react';
import { FiRefreshCw, FiShield } from "react-icons/fi";

const BackupModeWidget = ({ variant = 'error' }) => { // 'error' lub 'solution'
  
  // Konfiguracja treści i stylów ramki/tła (ale IKONA ma teraz stały styl)
  const config = {
    error: {
      title: "TRYB COMEBACKU",
      text: (
        <>
          Lepiej teraz niż na maturze. Dostaniesz <strong className="text-[#B88226]">2 zadania naprawcze</strong>, żeby poprawić błąd. Przeanalizuj rozwiązanie lub zapytaj Orła AI.
        </>
      ),
      icon: <FiRefreshCw size={20} className="animate-[spin_8s_linear_infinite]" />,
      // Style zewnętrzne (ramka, cień, dekoracja) - POMARAŃCZOWE
    //   gradient: "from-[#E09F2E] to-[#F8AB3B]",

      borderColor: "border-[#E09F2E]",
      shadow: "shadow-[0_4px_15px_-3px_rgba(224,159,46,0.15)]",
      titleColor: "text-[#E09F2E]"
    },
    solution: {
      title: "TRYB REALITY CHECK",
      text: (
        <>
          Przeanalizuj poniższe rozwiązanie, a w razie czego zapytaj Orła AI.  Dostaniesz <strong className="text-border-[#233855]">2 podobne zadania</strong>, żeby od razu utrwalić nową wiedzę.
        </>
      ),
      icon: <FiShield size={20} />,
      // Style zewnętrzne (ramka, cień, dekoracja) - GRANATOWE
    //   gradient: "from-[#233855] to-[#4B6CB7]",
      borderColor: "border-[#233855]",
      shadow: "shadow-[0_4px_15px_-3px_rgba(35,56,85,0.15)]",
      titleColor: "text-[#233855]"
    }
  };

  const current = config[variant];

  return (
    <div className={`w-full bg-white rounded-xl border ${current.borderColor} ${current.shadow} mt-4 p-4 flex items-center gap-4 relative overflow-hidden transition-all duration-300`}>
      
      {/* 1. IKONA - ZGODNA ZE STYLEM GOAL WIDGET */}
      {/* Tło zawsze Navy (#233855), Ikona zawsze Gold (#F8AB3B) */}
      <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-[#233855] flex items-center justify-center text-[#F8AB3B] shadow-md z-10">
          {current.icon}
      </div>

      {/* 2. TREŚĆ */}
      <div className="z-10">
          <h3 className={`text-base font-apotek uppercase tracking-wider ${current.titleColor} leading-none mb-1.5`}>
              {current.title}
          </h3>
          <p className="text-xs text-gray-600 leading-snug font-medium pr-2">
              {current.text}
          </p>
      </div>

      {/* Tło ozdobne - dynamiczny kolor zależny od trybu */}
      <div className={`absolute top-0 right-0 w-24 h-full bg-gradient-to-l ${current.gradient} opacity-5 pointer-events-none`} />
    </div>
  );
};

export default BackupModeWidget;